<template lang='pug'>
  IMList(:title='title' :listType='listType' :dialogType="dialogType" :im='getIM()' :createPvButton="true")
</template>

<script>
import IMList from "../components/IMListPV.vue";
import * as i18n from "../data/i18n.json";
export default {
  name: "MyRequestPV",
  components: {
    IMList
  },
  data() {
    return {
      i18n: i18n.default,
      title: "My Request PV",
      listType: "user",
      dialogType: "user",
      im: {
        headers: [
          {
            text: "IM Number",
            value: "imNo"
          },
          {
            text: "Subject",
            value: "imPerihal"
          },
          {
            text: "Submit Date",
            value: "imDate",
          },
          {
            text: "Business Unit",
            value: "imOrganization.name",
          },
          {
            text: "Status",
            value: "imStatus",
            align: "center"
          },
          {
            text: "Actions",
            value: "actions",
          }
        ],
        items: [],
        bisnisUnit: '',
        jumlah: 0
      }
    }
  },
  mounted() {
    this.filterImType = [8]; // Filter to show only PV (imType = 8)
  },
  methods: {
    getIM() {
      this.im.items = this.$store.state.dataRequests.data || [];
      this.im.jumlah = this.$store.state.dataRequests.jumlah || 0;
      if(this.im.items.length > 0){
        
        for (let i = 0; i < this.im.items.length; i++) {
          this.im.items[i].imStatusLabel = this.i18n.status[
            this.im.items[i].imStatus
          ].name;
          this.im.items[i].imTypeLabel = this.i18n.imType[
            this.im.items[i].imType
          ];
          
          this.im.items[i].imCategory = "PV";
        }
      }
      return this.im;
    },
  }
};
</script>

